module.exports = __webpack_public_path__ + "img/GENERAL-S-CROSS-3.c42b6b1b.jpg";